/*
 * @Autor: lianxiben
 * @Date: 2023-08-14 19:37:02
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-08-14 20:16:11
 */
import Index from '../../pages/sakura/cardTest/index';


const base = 'cardTest';

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/sakura/cardTest.js